import { useAuthStore, hasPermission, type PermissionAction } from '@/stores/auth';

/**
 * v0.3 (S-7/S-11): useAuthStore からの実効権限読み取りを薄くラップするフック。
 * 既存ページは `hasPermission(useAuthStore((s) => s.user?.effective_permissions), feature, action)`
 * を直接呼んでいたが (詳細設計書 §0 で確認済)、公開ゲート関連画面が増えるにあたり呼び出しを簡潔にする。
 */
export const useEffectivePermissions = () => {
  const effectivePermissions = useAuthStore((s) => s.user?.effective_permissions);
  const nonInheritingFeatures = useAuthStore((s) => s.user?.non_inheriting_features);
  return {
    effectivePermissions,
    hasPermissionForFeatureAction: (feature: string, action: PermissionAction) =>
      hasPermission(effectivePermissions, feature, action, nonInheritingFeatures),
  };
};

/** §8-172: `/auth/me` のレスポンス到着まで `user.effective_permissions` は undefined。
 *  `hasPermission`/`hasTenantWidePermission` はこれを fail-closed (=権限なし) として扱うため、
 *  未確定の間に権限判定してしまうと「権限がありません」等の誤表示が一瞬 (最悪、LoginPageの
 *  §8-172修正前はログインし直すまでずっと) 出る。この値が true になるまで権限に基づく分岐は
 *  保留し、ローディング状態を出すこと。 */
export const usePermsReady = () => {
  const user = useAuthStore((s) => s.user);
  return user !== null && user.effective_permissions !== undefined;
};
